import { Box, Typography } from "@material-ui/core";
import { Modale } from "bc-front-sagacomponents";
import React from "react";
import InstallDialogAction from "./InstallDialogAction";

export default function InstallDialog(props) {
  return (
    <Modale open={props.open} onClose={props.onClose}>
<Typography variant="h3" id="dialog-title">{props.title || "Install Web App"}</Typography>
      <div>
          {!!props.logo && (
            <Box mr={1}>
              <img src={props.logo} alt="logo" />
            </Box>
          )}
          {!!props.features && (
            <Box>
              <Typography variant="subtitle1">Fonctionnalités disponibles :</Typography>
              <Typography variant="body2" component="div">
                {props.features}
              </Typography>
            </Box>
          )}
      </div>
      <InstallDialogAction platform={props.platform} onSubmit={props.onSubmit} onClose={props.onClose} />
    </Modale>
      
  );
}
